import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TAlertStyle } from '@/shared/components/ui/alert/alert.types';

export const AlertContainer = styled(Stack)<TAlertStyle>`
  && {
    position: relative;
    background: ${({ theme, $color }) =>
      $color === 'red'
        ? theme.palette.danger.light
        : theme.palette.status[$color].background};

    padding: 0.75rem;

    border: 1px solid
      ${({ theme, $color }) => theme.palette.status[$color].stroke};

    border-radius: ${({ theme }) => theme.shape.containerRadius};

    .main-icon > svg {
      margin-top: 0.2rem;
      color: ${({ theme, $color }) => theme.palette.status[$color].text};
    }

    .close-button {
      position: absolute;
      top: 0.375rem;
      right: 0.375rem;
    }
  }
`;
